import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';
import { Props } from './types';

type T = Omit<Props, 'show'> & AppStyledProps;

export const FooterStyled = styled.div<T>`
  display: flex;
  justify-content: flex-end;

  button {
    font-size: 1em;
    background-color: #2055ff;
    padding: 0.4em 1em;
    color: white;

    &:hover {
      opacity: 0.7;
    }

    ${({ buttonColor, color }) =>
      buttonColor &&
      color &&
      `
      background-color: ${buttonColor};
      color: ${color}
    `}
  }

  ${({ theme }) =>
    theme.device.mobile &&
    `
  `}
`;
